var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistributorPaymentActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.004,
    height: 24,
    rx: 4,
    fill: "#2E6742"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10.714v4.429h12v-4.429H6zm12-.857H6v-1h12v1zm-6.572 4.572H6.857v-.858h4.571v.858zM5.714 8a.571.571 0 0 0-.571.571v6.858c0 .315.255.571.571.571h12.571a.571.571 0 0 0 .572-.571V8.57A.571.571 0 0 0 18.285 8H5.714z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistributorPaymentActiveIcon);
export default __webpack_public_path__ + "static/media/distributorPaymentActiveIcon.f25a7f76dc43f187fce1fd13edc4d1cb.svg";
export { ForwardRef as ReactComponent };